export default __webpack_public_path__ + "static/MarineDebrisTracker_Logo_Horizontal2-2b6087e6d7220e7a976075f795724d63.svg";